import {
  acceptCompanyJoinRequest$,
  createCompany$,
  createEmailCompanyInvites$,
  deleteCompanyLogo$,
  getCompanies$,
  getCompanyById$,
  getCompanyByShortName$,
  getCompanyEmployees$,
  getCompanyEmployeeSingle$,
  getCompanyJoinRequests$,
  getCompanyLogo$,
  rejectCompanyJoinRequest$,
  removeCompanyEmployee$,
  updateCompany$,
  updateCompanyEmployeePermissions$,
  updateCompanyLogo$
} from "../services/companies";
import {networkError, uiInfo, uiSuccess} from "./ui";
import * as R from 'ramda';
import {getMyDetails$} from "../services/users";

export const ADD_COMPANIES = 'ADD_COMPANIES';
export const addCompanies = (companies) => ({type: ADD_COMPANIES, payload: companies});
export const API_GET_COMPANY = 'API_GET_COMPANY';
export const getCompany = (id) => ({type: API_GET_COMPANY, payload: {id}});
export const API_GET_COMPANY_DONE = 'API_GET_COMPANY_DONE';
export const getCompanyDone = (response) => ({type: API_GET_COMPANY_DONE, payload: response});

export const CLEAR_COMPANY_SEARCH = 'CLEAR_COMPANY_SEARCH';
export const clearCompanySearch = () => ({ type: CLEAR_COMPANY_SEARCH, payload: {}});
export const API_GET_COMPANY_QUERY_START = 'API_GET_COMPANY_QUERY_START';
export const API_GET_COMPANY_QUERY_RESULTS = 'API_GET_COMPANY_QUERY_RESULTS';
export const API_GET_COMPANY_QUERY_DONE = 'API_GET_COMPANY_QUERY_DONE';

export const ADD_LOGOS = 'ADD_LOGOS';
export const addLogos = (photos) => ({ type: ADD_LOGOS, payload: photos });

export const getCompaniesQuery = (q) => async (dispatch, getState) => {
  try {
    dispatch({type: API_GET_COMPANY_QUERY_START, payload: {q}});
    if (!q) {
      dispatch(clearCompanySearch());
      return;
    }
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let { response, status: response_status } = await getCompanies$({ q, offset: nextOffset }).toPromise();
      if (response_status === 204) {
        dispatch({type: API_GET_COMPANY_QUERY_DONE, payload: {}});
        return;
      }
      if (!response) {
        dispatch({type: API_GET_COMPANY_QUERY_DONE, payload: {}});
        return;
      }
      let { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (getState().ui.companySearchTerm !== q) return;
      if (results.length > 0) dispatch ({ type: API_GET_COMPANY_QUERY_RESULTS, payload: {results}});
      nextOffset = R.last(results).id
    } while (soFar < theSize);
    dispatch({ type: API_GET_COMPANY_QUERY_DONE, payload: {}});
  } catch (error) {
    dispatch(networkError({...error, number: '10031-'+error.status}));
  }
};

export const getCompanyByShortName = (qex) => async (dispatch, getState) => {
  if (!qex) { return; }
  try {
      let { response, status: response_status } = await getCompanyByShortName$({ qex }).toPromise();
      if (response_status === 204 || !response) { return; }
      dispatch(getCompanyDone(response.results[0]));
  } catch (error) {
    dispatch(networkError({...error, number: '10149-'+error.status}));
  }
};

export const getMyCompany = () => async (dispatch, getState) => {
  try {
    let state = getState();
    let profile = getState().profile;
    if (R.isEmpty(profile)) {
      let {response, status} = await getMyDetails$().toPromise();
      profile = response;
    }
    const companyId = profile.companyid;
    let {response, status} = await getCompanyById$({companyId}).toPromise();
    dispatch(getCompanyDone(response));
  } catch (error) {
    dispatch(networkError({...error, number: '10032-'+error.status}));
  }
};

export const createCompany = (company) => async (dispatch, getState) => {
  try {
    let { response, status } = await createCompany$({ company }).toPromise();
    let companyId = response;
    ({ response, status } = await getCompanyById$({ companyId }).toPromise());
    dispatch(getCompanyDone(response));
  } catch (error) {
    dispatch(networkError({...error, number: '10033-'+error.status}));
  }
};

export const updateCompany = (companyId, company) => async (dispatch, getState) => {
  try {
    await updateCompany$({ companyId, company }).toPromise();
    let { response, status } = await getCompanyById$({ companyId }).toPromise();
    dispatch(getCompanyDone(response));
  } catch (error) {
    dispatch(networkError({...error, number: '10034-'+error.status}));
  }
};

export const API_GET_COMPANY_JOIN_REQUESTS_START = 'API_GET_COMPANY_JOIN_REQUESTS_START';
export const API_GET_COMPANY_JOIN_REQUESTS_DONE = 'API_GET_COMPANY_JOIN_REQUESTS_DONE';
export const API_GET_COMPANY_JOIN_REQUESTS_RESULTS = 'API_GET_COMPANY_JOIN_REQUESTS_RESULTS';

export const getJoinRequests = () => async (dispatch, getState) => {
  try {
    let { response, status } = await getMyDetails$().toPromise();
    let { companyid } = response;
    dispatch({type: API_GET_COMPANY_JOIN_REQUESTS_START, payload: {}});
    let soFar = 0;
    let theSize = 0;
    let nextOffset;
    do {
      let { response, status: response_status } = await getCompanyJoinRequests$({ companyId: companyid, offset: nextOffset }).toPromise();
      if (response_status === 204) {
        dispatch({type: API_GET_COMPANY_JOIN_REQUESTS_DONE, payload: {}});
        return;
      }
      if (!response) {
        dispatch({type: API_GET_COMPANY_JOIN_REQUESTS_DONE, payload: {}});
        return;
      }
      let { results, size } = response;
      theSize = size;
      soFar += results.length;
      if (results.length > 0) dispatch ({ type: API_GET_COMPANY_JOIN_REQUESTS_RESULTS, payload: {results}});
      nextOffset = R.last(results).id
    } while (soFar < theSize);
    dispatch({ type: API_GET_COMPANY_JOIN_REQUESTS_DONE, payload: {}});
  } catch (error) {
    dispatch(networkError({...error, number: '10035-'+error.status}));
  }
};

export const acceptJoinRequest = (id) => async (dispatch, getState) => {
  try {
    let { response, status } = await getMyDetails$().toPromise();
    let { companyid } = response;
    await acceptCompanyJoinRequest$({ companyId: companyid, userId: id }).toPromise();
    dispatch(getCompanyEmployees());
    dispatch(getJoinRequests());
  } catch (error) {
    dispatch(networkError({...error, number: '10036-'+error.status}));
  }
};

export const rejectJoinRequest = (id) => async (dispatch, getState) => {
  try {
    let { response, status } = await getMyDetails$().toPromise();
    let { companyid } = response;
    let { response2, status2 } = await rejectCompanyJoinRequest$({ companyId: companyid, userId: id }).toPromise();
    dispatch(getJoinRequests());
  } catch (error) {
    dispatch(networkError({...error, number: '10037-'+error.status}));
  }
};

export const API_GET_COMPANY_EMPLOYEES_START_CLEAR = 'API_GET_COMPANY_EMPLOYEES_START_CLEAR';
export const API_GET_COMPANY_EMPLOYEES_START = 'API_GET_COMPANY_EMPLOYEES_START';
export const API_GET_COMPANY_EMPLOYEES_DONE = 'API_GET_COMPANY_EMPLOYEES_DONE';
export const API_GET_COMPANY_EMPLOYEES_RESULTS = 'API_GET_COMPANY_EMPLOYEES_RESULTS';

export const getCompanyEmployees = ({id} = {}) => async (dispatch, getState) => {
  try {
    let { response, status } = await getMyDetails$().toPromise();
    let { companyid: companyId } = response;
    dispatch({type: API_GET_COMPANY_EMPLOYEES_START, payload: {}});
    if (id) {
      if (id.length) {
        // Select group of users by ID from company
        let groups = R.splitEvery(40, id);
        for (let group of groups) {
          let { response, status: response_status } = await getCompanyEmployees$({ companyId, id: group }).toPromise();
          if (response_status === 204) {
            dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
            return;
          }
          if (!response) {
            dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
            return;
          }
          let { results } = response;
          if (results.length > 0) dispatch ({ type: API_GET_COMPANY_EMPLOYEES_RESULTS, payload: results});
        }
      } else {
        // Select single user by ID from company
        let { response, status: response_status } = await getCompanyEmployeeSingle$({ companyId, id }).toPromise();
        if (response_status === 404) {
          dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
          return;
        }
        if (!response) {
          dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
          return;
        }
        let { results } = response;
        if (results.length > 0) dispatch ({ type: API_GET_COMPANY_EMPLOYEES_RESULTS, payload: results});
      }
    } else {
      // Clear current list of employyes and select all users in company
      dispatch({type: API_GET_COMPANY_EMPLOYEES_START_CLEAR, payload: {}});
      let soFar = 0;
      let theSize = 0;
      let nextOffset;
      do {
        let { response, status: response_status } = await getCompanyEmployees$({ companyId, offset: nextOffset }).toPromise();
        if (response_status === 204) {
          dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
          return;
        }
        if (!response) {
          dispatch({type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
          return;
        }
        let { results, size } = response;
        theSize = size;
        soFar += results.length;
        if (results.length > 0) dispatch ({ type: API_GET_COMPANY_EMPLOYEES_RESULTS, payload: results});
        nextOffset = R.last(results).id
      } while (soFar < theSize);
    }
    dispatch({ type: API_GET_COMPANY_EMPLOYEES_DONE, payload: {}});
  } catch (error) {
    dispatch(networkError({...error, number: '10038-'+error.status}));
  }
};

export const quickInviteCompanyUserEmailSingle = (inviteUserEmail) => async (dispatch, getState) => {
  try {
    dispatch(uiInfo('Sending invite to ' + inviteUserEmail));
    let companyId = getState().profile.companyid;
    let { response: [id] } = await createEmailCompanyInvites$({ companyId, inviteUserEmails: [inviteUserEmail] }).toPromise();
    let { response: results } = await getCompanyEmployeeSingle$({ companyId, id }).toPromise();
    dispatch({ type: API_GET_COMPANY_EMPLOYEES_RESULTS, payload: [results]});
    dispatch(uiSuccess('Invited ' + inviteUserEmail + ' to your company'));
  } catch (error) {
    let { response, status } = error;
    if (status === 409) {
      dispatch(uiInfo(inviteUserEmail + ' already has an account in cProject.'))
    } else {
      dispatch(networkError({...error, number: '10111-'+error.status}));
    }
  }
};

export const updateCompanyEmployeePermissions = (userId, permissions) => async (dispatch, getState) => {
  try {
    let { response: { companyid: companyId } } = await getMyDetails$().toPromise();
    let { response, status } = await updateCompanyEmployeePermissions$({ companyId, userId, permissions }).toPromise();
    dispatch(getCompanyEmployees());
  } catch (error) {
    dispatch(networkError({...error, number: '10039-'+error.status}));
  }
};

export const removeCompanyEmployee = (userId) => async (dispatch, getState) => {
  try {
    let { response: { companyid: companyId } } = await getMyDetails$().toPromise();
    let { response, status } = await removeCompanyEmployee$({ companyId, userId }).toPromise();
    dispatch(getCompanyEmployees());
  } catch (error) {
    dispatch(networkError({...error, number: '10040-'+error.status}));
  }
};

export const getCompanyLogo = ({ id }) => async (dispatch, getState) => {
  try {
    const { response, status } = await getCompanyLogo$({ companyId: id }).toPromise();
    if (!response) return null;
    dispatch(addLogos([{ ...response, id }]));
  } catch (error) {
    const {response, status} = error;
    if (status === 404 && response.code === 'photo_not_found') {
      dispatch(addLogos([{ id, url: null }]));
    } else {
      dispatch(networkError({ ...error, number: '10140-' + error.status }));
    }
  }
};

export const uploadCompanyLogo = ({ id, file }) => async (dispatch, getState) => {
  try {
    dispatch(uiInfo('Uploading file'));
    let { response, status } = await updateCompanyLogo$({ companyId: id, file }).toPromise();
    let fileId = response;
    dispatch(getCompanyLogo({ id }));
    dispatch(uiSuccess('File upload successful'));
  } catch (error) {
    dispatch(networkError({ ...error, number: '10150-' + error.status }));
  }
};

export const deleteCompanyLogo = ({ id }) => async (dispatch, getState) => {
  try {
    const { response, status } = await deleteCompanyLogo$({ companyId: id }).toPromise();
    dispatch(getCompanyLogo({ id }));
  } catch (error) {
    dispatch(networkError({ ...error, number: '10151-' + error.status }));
  }
};



// WEBPACK FOOTER //
// ./src/actions/companies.js